import type { IconSvgObject } from './types';

const ImageFlipHorizontalIcon: IconSvgObject = [
  ["path", { d: "M10.5 5L2 19H10.5L10.5 5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 5L22 19H13.5L13.5 5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ImageFlipHorizontalIcon;
